var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9745 21.4821C19.9814 21.4821 22.4284 19.0351 22.4284 16.0282C22.4284 13.0213 19.9814 10.5743 16.9745 10.5743C13.9676 10.5743 11.5206 13.0213 11.5206 16.0282C11.5206 19.0351 13.9676 21.4821 16.9745 21.4821ZM16.9745 13.3013C18.4779 13.3013 19.7014 14.5248 19.7014 16.0282C19.7014 17.5316 18.4779 18.7551 16.9745 18.7551C15.4711 18.7551 14.2476 17.5316 14.2476 16.0282C14.2476 14.5248 15.4711 13.3013 16.9745 13.3013Z",
    fill: "url(#paint0_linear_169_4820)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3812 39.2127H12.8816C12.1299 39.2127 11.5163 38.599 11.5163 37.8473V31.0281C11.5163 28.0212 13.9632 25.5742 16.9701 25.5742C18.4238 25.5742 19.7968 26.1419 20.8285 27.1621C21.8564 28.2053 22.424 29.5783 22.424 31.0319V32.3973C22.424 33.149 23.0338 33.7627 23.7894 33.7627C24.5411 33.7627 25.1547 33.1528 25.1547 32.3973V25.5781C25.1547 22.5711 27.6017 20.1242 30.6086 20.1242C32.0622 20.1242 33.4353 20.6918 34.467 21.712C35.4949 22.7552 36.0625 24.1283 36.0625 25.5819V32.4011C36.0625 33.1528 36.6723 33.7665 37.4279 33.7665C38.1796 33.7665 38.7932 33.1567 38.7932 32.4011V25.5819C38.7932 23.4073 37.9456 21.3515 36.3961 19.7867C34.839 18.2488 32.787 17.4011 30.6086 17.4011C26.3015 17.4011 22.773 20.7455 22.4585 24.9721C20.9435 23.6105 19.0144 22.8588 16.974 22.8588C12.4636 22.8588 8.79321 26.5293 8.79321 31.0396V37.8588C8.79321 40.114 10.6265 41.9512 12.8856 41.9512H14.3851C15.1369 41.9512 15.7505 41.3414 15.7505 40.5858C15.7505 39.8341 15.1407 39.2205 14.3851 39.2205L14.3812 39.2127Z",
    fill: "url(#paint1_linear_169_4820)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.612 16.0287C33.6189 16.0287 36.0658 13.5818 36.0658 10.5748C36.0658 7.56793 33.6189 5.12097 30.612 5.12097C27.605 5.12097 25.1581 7.56793 25.1581 10.5748C25.1581 13.5818 27.605 16.0287 30.612 16.0287ZM30.612 7.84796C32.1154 7.84796 33.3388 9.07144 33.3388 10.5748C33.3388 12.0783 32.1154 13.3017 30.612 13.3017C29.1086 13.3017 27.8851 12.0783 27.8851 10.5748C27.8851 9.07144 29.1086 7.84796 30.612 7.84796Z",
    fill: "url(#paint2_linear_169_4820)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_4820",
    x1: 8.65482,
    y1: 76.0778,
    x2: 49.147,
    y2: 53.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_4820",
    x1: 0.911278,
    y1: 164.83,
    x2: 100.692,
    y2: 97.1746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_4820",
    x1: 22.2923,
    y1: 70.6244,
    x2: 62.7844,
    y2: 48.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFeature2);
export default __webpack_public_path__ + "static/media/web_feature_2.ed83154e42c05326e5fed61b4b42e4ff.svg";
export { ForwardRef as ReactComponent };